import { render } from "./CrmCompanyRule.vue?vue&type=template&id=8c57cafa&scoped=true"
import script from "./CrmCompanyRule.vue?vue&type=script&lang=js"
export * from "./CrmCompanyRule.vue?vue&type=script&lang=js"

import "./CrmCompanyRule.vue?vue&type=style&index=0&id=8c57cafa&lang=less"
import "./CrmCompanyRule.vue?vue&type=style&index=1&id=8c57cafa&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c57cafa"]])

export default __exports__